// Centralized translation strings for EN / ES.
export const dict = {
  en: {
    'nav.shop': 'Shop',
    'nav.shipping': 'Shipping',
    'nav.about': 'About',
    'nav.contact': 'Contact',

    'hero.eyebrow': 'Open Today · Se Habla Español',
    'hero.title.a': "The Bronx's Most ",
    'hero.title.em': 'Trusted',
    'hero.title.b': ' Appliance Store.',
    'hero.sub': 'Visit our Ogden Ave showroom. Bilingual service in English and Spanish, and we ship appliances to the Dominican Republic.',
    'hero.cta1': 'Shop Catalog',
    'hero.cta2': 'Visit Us In Store',
    'hero.financing': 'Financing Available',

    'info.visit': 'Visit Us',
    'info.call': 'Call Us',
    'info.today': "Today's Hours",

    'how.kicker': 'How It Works',
    'how.title.a': 'Three simple ',
    'how.title.em': 'steps',
    'how.title.b': '.',
    'how.sub': 'Browse the catalog, see if you qualify with Affirm, then pay in store on Ogden Ave.',
    'how.1t': 'Check if you qualify',
    'how.1d': 'Open the Affirm app to see if you qualify.',
    'how.2t': 'Get approved in the Affirm app',
    'how.2d': 'Finish your application in the Affirm app and, if approved, you’ll receive a one-time virtual card to use at our store.',
    'how.3t': 'Pay in store at 1015 Ogden Ave',
    'how.3d': 'Come see the appliance in person and pay with your Affirm card. Our bilingual team is here to help you choose the right model.',
    'how.disclaimer': 'Estimated payments. Approval and final terms are set by Affirm.',
    'how.wa': 'Message on WhatsApp',
    'how.visit': 'Visit us in store',

    'products.kicker': 'Shop the Store',
    'products.title.a': 'Every appliance your ',
    'products.title.em': 'home',
    'products.title.b': ' needs.',
    'products.sub': 'Refrigerators, stoves, washers and dryers, microwaves. Come see them in our Ogden Ave showroom.',
    'products.viewAll': 'See All Categories',
    'products.shopCat': 'Shop {cat}',
    'cat.waCta': 'Ask us on WhatsApp',

    'shop.title.a': 'Browse our ',
    'shop.title.em': 'showroom',
    'shop.title.b': ' categories.',
    'shop.sub': 'Four categories, one store. Ask us about current models and prices on WhatsApp or in person.',
    'shop.allCategories': 'All Categories',
    'shop.askModels': 'Ask us about current models and prices.',
    'shop.startingAt': 'Starting at',
    'shop.washersFrom': 'Washers from',
    'shop.towersFrom': 'Laundry towers from',
    'shop.callUs': 'Call the Store',
    'shop.waUs': 'Ask on WhatsApp',

    'product.back': 'Back to Shop',
    'product.askWa': 'Ask on WhatsApp',
    'product.call': 'Call the Store',
    'product.inStore': 'Come see it in store',
    'product.inStoreLong': 'Come see it in store before you decide — the model, finish, and sound in person.',
    'affirm.apply': 'Apply with Affirm',
    'hero.financingHow': 'How financing works',
    'affirm.disclaimer': 'Estimated payment. Approval and final terms are set by Affirm.',
    'product.specs': 'Specifications',
    'product.brand': 'Brand',
    'product.model': 'Model',
    'product.category': 'Category',
    'product.inStock': 'In Stock',
    'product.outStock': 'Call to confirm',
    'product.notFound': 'Product not found',
    'product.related': 'You may also like',
    'product.compareAdd':    'Compare',
    'product.compareAdded':  'Added to compare',
    'compare.title':         'Compare on WhatsApp',
    'compare.subtitle':      '{n} of {max} selected',
    'compare.cta':           'Compare on WhatsApp',
    'compare.clear':         'Clear',
    'compare.full':          'You can compare up to {max} products at a time.',
    'compare.minTwo':        'Pick at least 2 products to compare.',

    'ship.kicker': 'Shipping',
    'ship.title.a': 'We ship to the ',
    'ship.title.em': 'Dominican Republic',
    'ship.title.b': '.',
    'ship.sub': 'Ask us how. Our team coordinates shipping from our Bronx store to la isla.',
    'ship.cta': 'Ask on WhatsApp',
    'ship.flag': 'Shipping to Dominican Republic',

    'why.kicker': 'Why Nathanael',
    'why.title.a': 'Trusted by Bronx families ',
    'why.title.em': 'every day',
    'why.title.b': '.',
    'why.sub': 'A real showroom with bilingual staff and shipping to the Dominican Republic.',
    'why.1t': 'Bilingual Staff', 'why.1d': 'Full service in English and Spanish — every step of the way.',
    'why.2t': 'International Shipping', 'why.2d': 'Dedicated shipping to the Dominican Republic — ask us how.',
    'why.3t': 'Visit Our Showroom', 'why.3d': 'Walk in to our Ogden Ave showroom and our bilingual team will help you choose the right model.',

    'contact.kicker': 'Visit · Call · Message',
    'contact.title.a': 'Come see the showroom ',
    'contact.title.em': 'in person',
    'contact.title.b': '.',
    'contact.sub': 'Ogden Ave, just off the Major Deegan.',
    'contact.hoursTitle': 'Store Hours',
    'contact.address': 'Address',
    'contact.phone': 'Phone',
    'contact.directions': 'Get Directions',
    'contact.today': 'Today',

    'days.0': 'Sunday', 'days.1': 'Monday', 'days.2': 'Tuesday', 'days.3': 'Wednesday',
    'days.4': 'Thursday', 'days.5': 'Friday', 'days.6': 'Saturday',

    'foot.tag': 'Family owned · Serving the Bronx and the DR community.',

    // categories
    'cat.refrigerators':  'Refrigerators',
    'cat.stoves':         'Stoves & Ranges',
    'cat.washers-dryers': 'Washers & Dryers',
    'cat.microwaves':     'Microwaves',
    'cat.refrigerators.d':  'French door, side-by-side, top-freezer.',
    'cat.stoves.d':         'Gas, electric, convection.',
    'cat.washers-dryers.d': 'Front-load, top-load, stackable.',
    'cat.microwaves.d':     'Over-the-range, countertop, built-in.',
  },

  es: {
    'nav.shop': 'Tienda',
    'nav.shipping': 'Envíos',
    'nav.about': 'Nosotros',
    'nav.contact': 'Contacto',

    'hero.eyebrow': 'Abierto Hoy · We Speak English',
    'hero.title.a': 'La tienda de electrodomésticos ',
    'hero.title.em': 'más confiable',
    'hero.title.b': ' del Bronx.',
    'hero.sub': 'Visita nuestra tienda en Ogden Ave. Atención bilingüe en español e inglés, y enviamos electrodomésticos a la República Dominicana.',
    'hero.cta1': 'Ver Catálogo',
    'hero.cta2': 'Visítanos en Tienda',
    'hero.financing': 'Financiamiento Disponible',

    'info.visit': 'Visítanos',
    'info.call': 'Llámanos',
    'info.today': 'Horario de Hoy',

    'how.kicker': 'Cómo Funciona',
    'how.title.a': 'Tres pasos ',
    'how.title.em': 'sencillos',
    'how.title.b': '.',
    'how.sub': 'Explora el catálogo, verifica si calificas con Affirm y luego paga en nuestra tienda en Ogden Ave.',
    'how.1t': 'Verifica si calificas',
    'how.1d': 'Abre la app de Affirm para ver si calificas.',
    'how.2t': 'Obtén aprobación en la app de Affirm',
    'how.2d': 'Completa tu solicitud en la app de Affirm y, si te aprueban, recibirás una tarjeta virtual de un solo uso para usar en nuestra tienda.',
    'how.3t': 'Paga en tienda en 1015 Ogden Ave',
    'how.3d': 'Ven a ver los electrodomésticos en persona y paga con tu tarjeta de Affirm. Nuestro equipo bilingüe te ayuda a elegir el modelo adecuado.',
    'how.disclaimer': 'Pagos estimados. La aprobación y los términos finales los establece Affirm.',
    'how.wa': 'Escríbenos por WhatsApp',
    'how.visit': 'Visítanos en la tienda',

    'products.kicker': 'Compra en Tienda',
    'products.title.a': 'Cada electrodoméstico que tu ',
    'products.title.em': 'hogar',
    'products.title.b': ' necesita.',
    'products.sub': 'Neveras, estufas, lavadoras y secadoras, microondas. Ven a verlos en nuestra tienda en Ogden Ave.',
    'products.viewAll': 'Ver Todas las Categorías',
    'products.shopCat': 'Ver {cat}',
    'cat.waCta': 'Pregúntanos por WhatsApp',

    'shop.title.a': 'Explora las categorías de nuestra ',
    'shop.title.em': 'tienda',
    'shop.title.b': '.',
    'shop.sub': 'Cuatro categorías, una tienda. Pregúntanos por modelos y precios actuales por WhatsApp o en persona.',
    'shop.allCategories': 'Todas las Categorías',
    'shop.askModels': 'Pregúntanos por los modelos y precios actuales.',
    'shop.startingAt': 'Desde',
    'shop.washersFrom': 'Lavadoras desde',
    'shop.towersFrom': 'Torres desde',
    'shop.callUs': 'Llamar a la Tienda',
    'shop.waUs': 'Preguntar por WhatsApp',

    'product.back': 'Volver a la Tienda',
    'product.askWa': 'Preguntar por WhatsApp',
    'product.call': 'Llamar a la Tienda',
    'product.inStore': 'Ven a verlo en la tienda',
    'product.inStoreLong': 'Ven a verlo en persona antes de decidir — el modelo, el acabado y el sonido en vivo.',
    'affirm.apply': 'Solicitar con Affirm',
    'hero.financingHow': 'Cómo funciona el financiamiento',
    'affirm.disclaimer': 'Pago estimado. La aprobación y los términos finales los establece Affirm.',
    'product.specs': 'Especificaciones',
    'product.brand': 'Marca',
    'product.model': 'Modelo',
    'product.category': 'Categoría',
    'product.inStock': 'En Existencia',
    'product.outStock': 'Llamar para confirmar',
    'product.notFound': 'Producto no encontrado',
    'product.related': 'También te puede gustar',
    'product.compareAdd':    'Comparar',
    'product.compareAdded':  'Agregado a comparación',
    'compare.title':         'Comparar por WhatsApp',
    'compare.subtitle':      '{n} de {max} seleccionados',
    'compare.cta':           'Comparar por WhatsApp',
    'compare.clear':         'Limpiar',
    'compare.full':          'Puedes comparar hasta {max} productos a la vez.',
    'compare.minTwo':        'Selecciona al menos 2 productos para comparar.',

    'ship.kicker': 'Envíos',
    'ship.title.a': 'Enviamos a la ',
    'ship.title.em': 'República Dominicana',
    'ship.title.b': '.',
    'ship.sub': 'Pregúntanos cómo. Nuestro equipo coordina envíos desde nuestra tienda en el Bronx hasta la isla.',
    'ship.cta': 'Preguntar por WhatsApp',
    'ship.flag': 'Envíos a República Dominicana',

    'why.kicker': 'Por Qué Nathanael',
    'why.title.a': 'Las familias del Bronx confían en nosotros ',
    'why.title.em': 'cada día',
    'why.title.b': '.',
    'why.sub': 'Una tienda real con personal bilingüe y envíos a la República Dominicana.',
    'why.1t': 'Personal Bilingüe', 'why.1d': 'Servicio completo en español e inglés — en cada paso.',
    'why.2t': 'Envíos Internacionales', 'why.2d': 'Envíos dedicados a la República Dominicana — pregúntanos cómo.',
    'why.3t': 'Visita Nuestra Tienda', 'why.3d': 'Visita nuestra tienda en Ogden Ave y nuestro equipo bilingüe te ayudará a elegir el modelo adecuado.',

    'contact.kicker': 'Visítanos · Llámanos · Escríbenos',
    'contact.title.a': 'Ven a ver la tienda ',
    'contact.title.em': 'en persona',
    'contact.title.b': '.',
    'contact.sub': 'Avenida Ogden, cerca de la Major Deegan.',
    'contact.hoursTitle': 'Horario de la Tienda',
    'contact.address': 'Dirección',
    'contact.phone': 'Teléfono',
    'contact.directions': 'Cómo Llegar',
    'contact.today': 'Hoy',

    'days.0': 'Domingo', 'days.1': 'Lunes', 'days.2': 'Martes', 'days.3': 'Miércoles',
    'days.4': 'Jueves', 'days.5': 'Viernes', 'days.6': 'Sábado',

    'foot.tag': 'Negocio familiar · Al servicio del Bronx y la comunidad dominicana.',

    'cat.refrigerators':  'Neveras',
    'cat.stoves':         'Estufas',
    'cat.washers-dryers': 'Lavadoras y Secadoras',
    'cat.microwaves':     'Microondas',
    'cat.refrigerators.d':  'Puerta francesa, side-by-side, congelador superior.',
    'cat.stoves.d':         'Gas, eléctricas, convección.',
    'cat.washers-dryers.d': 'Carga frontal, carga superior, apilables.',
    'cat.microwaves.d':     'Sobre la estufa, de mesa, empotrados.',
  },
};

// store info
export const STORE = {
  name: 'Nathanael Appliances Corp',
  phone: '(347) 961-5885',
  phoneRaw: '+13479615885',
  whatsapp: '13479615885',
  address: '1015 Ogden Ave, Bronx, NY 10452',
  hours: [
    // index = day-of-week (0=Sun .. 6=Sat)
    { day: 0, openLabel: '11:00 AM – 5:00 PM' },
    { day: 1, openLabel: '9:00 AM – 7:00 PM' },
    { day: 2, openLabel: '9:00 AM – 7:00 PM' },
    { day: 3, openLabel: '9:00 AM – 7:00 PM' },
    { day: 4, openLabel: '9:00 AM – 7:00 PM' },
    { day: 5, openLabel: '9:00 AM – 7:00 PM' },
    { day: 6, openLabel: '9:00 AM – 7:00 PM' },
  ],
};
